import WhyUsCarousel from './WhyUsCarousel'

export default WhyUsCarousel
